import React, { useState } from 'react';
import { ForecastingContent } from 'src/features/Forecasting/components/templates/ForecastingContent';
import { useForecastingDataContext } from 'src/features/Forecasting/contexts/ForecastingDataContext';
import { PageModelLayout } from 'src/components/molecules/PageModelLayout';
import { CreateForecastButton } from 'src/features/Forecasting/components/molecules/CreateForecastButton';
import { useKpiMetricLabels } from 'src/hooks/useKpiMetricLabels';

export const ForecastPage: React.FC = () => {
  const [isCreateForecastOpen, setIsCreateForecastOpen] = useState(false);
  const { forecastComponentsAvailable, isCheckingComponents } =
    useForecastingDataContext();
  const { metricLabel } = useKpiMetricLabels();

  const showCreateButton =
    !isCreateForecastOpen &&
    forecastComponentsAvailable &&
    !isCheckingComponents;

  return (
    <PageModelLayout
      extraButtons={
        showCreateButton ? (
          <CreateForecastButton onClick={() => setIsCreateForecastOpen(true)} />
        ) : null
      }
      pageTitle={isCreateForecastOpen ? 'Create Forecast' : 'Forecasting'}
      pageSubtitle={`Predict future ${metricLabel.toLowerCase()} based on planned media spend`}>
      <ForecastingContent
        isCreateForecastOpen={isCreateForecastOpen}
        onClose={() => setIsCreateForecastOpen(false)}
      />
    </PageModelLayout>
  );
};
